<template>
    <div class="container main mt-5" v-html="terms">
    </div>
</template>

<script>
export default {
    name: 'terms',
    props: {
        termType: { type: String, required: true }
    },
    computed: {
        terms() {
            switch (this.termType) {
                case 'privacy-policy':
                    return this.$root.system.privacy_policy
                case 'cookie-policy':
                    return this.$root.system.cookie_policy
                default:
                    return this.$root.system.terms
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components/pages/terms/terms.vue